import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { CustomInputLabel } from '../../components/restyled-mui/CustomInputs'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  label: {
    fontSize: 12,
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    minWidth: 80,
  },
  toggleButton: {
    '&.Mui-selected': {
      backgroundColor: '#E6F1FC',
      color: '#368ED8',
      borderColor: '#A9CFF2',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#D6E9FB',
    },
  },
}))

const SelectorRow = ({
  label,
  options,
  value,
  onChange,
  multiple = false,
  labelWidth,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <CustomInputLabel
        className={classes.label}
        style={labelWidth ? { minWidth: labelWidth } : undefined}
      >
        {label}
      </CustomInputLabel>
      <ToggleButtonGroup
        exclusive={!multiple}
        size="small"
        value={value}
        onChange={(_, newValue) => {
          if (multiple) {
            onChange(newValue ?? [])
          } else if (newValue !== null) {
            onChange(newValue)
          }
        }}
      >
        {options.map(opt => {
          const val = typeof opt === 'object' ? opt.value : opt
          const lbl = typeof opt === 'object' ? opt.label : opt
          return (
            <ToggleButton
              key={val}
              value={val}
              className={classes.toggleButton}
            >
              {lbl}
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </Box>
  )
}

export default SelectorRow
